import React, { Fragment } from 'react'
import Image from '../styles/image'
import { PlanetIcon, PlanetsProgress } from '../styles/planet'

export default ({ planetType, planets }) => {
  const currentPlanetTypeIndex = planets.findIndex(planet => planet.type === planetType)

  let currentBorderColor
  switch (planetType) {
    case 'EARTH':
      currentBorderColor = 'rgba(1, 160, 200, 0.2)'
      break
    case 'MOON':
      currentBorderColor = 'rgba(97, 105, 116, 0.2)'
      break
    case 'SUN':
      currentBorderColor = 'rgba(248, 156, 23, 0.2)'
      break
    case 'GALAXY':
      currentBorderColor = 'rgba(208, 212, 221)'
      break
    default:
      currentBorderColor = null
  }

  return (
    <PlanetsProgress>
      {planets.map((planet, index) =>
        <Fragment key={index}>
          <PlanetIcon
            isShown={currentPlanetTypeIndex === index}
            className={currentPlanetTypeIndex < index && 'not-passed'}>
            <Image
              isCircle
              src={require(`../planets/${planet.type.toLowerCase()}.png`)}
              width={currentPlanetTypeIndex === index ? '32px' : '24px'}
              position="relative"
              border={currentPlanetTypeIndex === index && `4px solid ${currentBorderColor}`}
            />
            {
              currentPlanetTypeIndex > index &&
              <Image src={require(`../assets/icons/flag.svg`)} right="7px" top="16px" width="12px" position="absolute" />
            }
          </PlanetIcon>
          {(index < planets.length - 1) && <Image src={require(`../assets/icons/gray_left.svg`)} />}
        </Fragment>
      )}
    </PlanetsProgress>
  )
}
